import axios from 'axios';
import { API_URL, getAuthHeader, getPDFAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Delivery } from '../Models/Delivery';
import { DeliveryItem } from '../Models/DeliveryItem';
import { SchedulerObj } from '../Models/SchedulerObj';
import { DeliveryAsset } from '../Models/DeliveryAsset';
import { Sopform } from '../Models/Sopform';
import { TestEmail } from '../Models/TestEmail';
import { BasicSearchRequest } from '../Models/BasicSearchRequest';

class DeliveryApi {
  static getDelivery(id: string) {
    return axios.get<Delivery>(
      `${API_URL}/api/delivery/${id}`,
      getAuthHeader()
    );
  }
  static getDeliveryList(request: BasicSearchRequest) {
    return axios.post<Delivery[]>(
      `${API_URL}/api/delivery/search`,
      request,
      getAuthHeader()
    );
  }
  static createBaseDelivery(jobId: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/start/${jobId}`,
      null,
      getAuthHeader()
    );
  }
  static addUpdateDelivery(request: Delivery) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery`,
      request,
      getAuthHeader()
    );
  }
  static deleteDelivery(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/delivery/${id}`,
      getAuthHeader()
    );
  }
  static submitDelivery(request: Delivery) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/submit`,
      request,
      getAuthHeader()
    );
  }
  static getDeliveryItem(id: string) {
    return axios.get<DeliveryItem>(
      `${API_URL}/api/delivery/deliveryitem/${id}`,
      getAuthHeader()
    );
  }
  static getDeliveryItemsList() {
    return axios.get<DeliveryItem[]>(
      `${API_URL}/api/delivery/deliveryitem`,
      getAuthHeader()
    );
  }
  static getDeliveryDeliveryItemsList(id: number) {
    return axios.get<DeliveryItem[]>(
      `${API_URL}/api/delivery/deliveryitem/list/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateDeliveryItem(request: DeliveryItem) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/deliveryitem`,
      request,
      getAuthHeader()
    );
  }
  static deleteDeliveryItem(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/delivery/deliveryitem/${id}`,
      getAuthHeader()
    );
  }
  static getDeliveryAssetList(deliveryId: number) {
    return axios.get<DeliveryAsset[]>(
      `${API_URL}/api/delivery/asset/list/${deliveryId}`,
      getAuthHeader()
    );
  }
  static getDeliveryAsset(id: string) {
    return axios.get<DeliveryAsset>(
      `${API_URL}/api/delivery/asset/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateDeliveryAsset(request: DeliveryAsset) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/asset`,
      request,
      getAuthHeader()
    );
  }
  static deleteDeliveryAsset(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/delivery/asset/${id}`,
      getAuthHeader()
    );
  }
  static addUpdateSOPForm(request: Sopform) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/sopform`,
      request,
      getAuthHeader()
    );
  }
  static sendDeliveryEmailTest(request: TestEmail) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/email/test`,
      request,
      getAuthHeader()
    );
  }
  static uploadSignature(deliveryId: number, request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/${deliveryId}/signature`,
      request,
      getAuthHeader()
    );
  }
  static sendToQuickbooks(request: Delivery) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/delivery/quickbooks/send`,
      request,
      getAuthHeader()
    );
  }
  static getQBInvoice(deliveryId: number) {
    return axios.get(
      `${API_URL}/api/delivery/quickbooks/get/${deliveryId}`,
      getAuthHeader()
    );
  }
  static getDropTicketReport(deliveryId: number) {
    return axios.get(
      `${API_URL}/api/delivery/getdropticket/${deliveryId}`,
      getPDFAuthHeader()
    );
  }
  static getInvoiceReport(deliveryId: number) {
    return axios.get(
      `${API_URL}/api/delivery/getinvoicereport/${deliveryId}`,
      getPDFAuthHeader()
    );
  }
}

export default DeliveryApi;
